var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('bill-define',{attrs:{"type":_vm.type,"options":_vm.options}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-110f5c8a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/pages/systemDefine/paymentDefine.vue
// module id = null
// module chunks = 